import { useFeatureFlags } from '@client/contexts/FeatureFlagsContext';

// Whether the reframed Edward Jones distribution-partner experience is active for the current
// advisor. When on: connecting a partner is a factual "who I work with" election rather than a
// sharing directive, and clients are shared only one by one from the Clients table. Nothing changes
// for advisors without this flag.
export function useIsDistributionPartnersForEdj(): boolean {
  const { flags } = useFeatureFlags();

  return flags.distributionPartnersForEdj === true;
}
